<template>
        <i class="mdi mdi-inbox-multiple"></i>
</template>

<script>
    export default {
        name: 'BoxIcon'
    }
</script>

<style>

</style>